module.exports = __webpack_public_path__ + "static/colors-tagging-bold-do-1d2293b33e7321ed5306d6af45348ef9.png";